module.exports = __webpack_public_path__ + "img/arrow-right.b5490835.svg";